import React, { useRef, useState } from 'react';
import ReactSlick from 'react-slick';
import Thumbnail from './Thumbnail';
import ArrowSvg from '../../reusable-components/icons/ArrowSvg';

const VerticalHorizontalSlider = ({
  totalSlides,
  handleClick,
  slidesToShowDesktop,
  slidesToShowMobile,
  slidesToScrollDesktop,
  slidesToScrollMobile,
  autoplay,
  infinite,
  focusOnSelect,
  touchThreshold,
  speed,
  data,
  brand,
}) => {
  const slick = useRef();
  const slideRef = useRef();
  const [activeSlide, setActiveSlide] = useState(0);

  const params = {
    slidesToShow: slidesToShowMobile,
    slidesToScroll: slidesToScrollMobile,
    dots: false,
    arrows: false,
    autoplay,
    accessibility: false,
    draggable: true,
    infinite,
    lazyLoad: true,
    swipeToSlide: true,
    focusOnSelect,
    touchThreshold,
    speed,
    afterChange: ((current) => {
      setActiveSlide(current);
    }),
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: slidesToShowMobile,
          slidesToScroll: slidesToScrollMobile,
          vertical: false,
        },
      },
      {
        breakpoint: 3000,
        settings: {
          slidesToShow: slidesToShowDesktop,
          slidesToScroll: slidesToScrollDesktop,
          vertical: true,
          verticalSwiping: true,
        },
      },
    ],
  };

  return (
    <div className="thumbnails">
      {totalSlides > 3 && (
        <div
          className="arrow arrow-top"
          onClick={() => activeSlide !== 0 && slick.current.slickPrev()}
          role="button"
          tabIndex="0"
          style={{ visibility: activeSlide === 0 ? 'hidden' : 'visible' }}
        >
          <ArrowSvg color="#000" />
        </div>
      )}
      <ReactSlick ref={slick} {...params}>
        {data.map(product => (
            <div className="slick-height" key={product.id} ref={slideRef}>
              <Thumbnail
                product={product}
                handleClick={e => handleClick(e, product)}
                brand={brand}
              />
            </div>
          ))
        }
      </ReactSlick>
      {totalSlides > 3 && (
        <div
          className="arrow arrow-down"
          onClick={() => activeSlide !== totalSlides - 1 && slick.current.slickNext()}
          role="button"
          tabIndex="0"
          style={{ visibility: activeSlide === totalSlides - 3 ? 'hidden' : 'visible' }}
        >
          <ArrowSvg color="#000" />
        </div>
      )}
    </div>
  );
};

export default VerticalHorizontalSlider;
